import request from '@/router/axios';

// 获取签约列表
export function pagePeSign(obj) {
  return request({
    url: '/dotadmin/dotadmin/pe/pagePeSign',
    method: 'get',
    params: obj,
  });
}

// 签约增删改
export function saveOrUpdateSignTr(obj) {
  return request({
    url: '/dotadmin/dotadmin/pe/saveOrUpdateSignTr',
    method: 'post',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: obj,
  });
}

// 单个查询PE签约
export function getPeSign(obj) {
  return request({
    url: '/dotadmin/dotadmin/pe/getPeSign',
    method: 'get',
    params: obj,
  });
}
